import { render, staticRenderFns } from "./ListCargos.vue?vue&type=template&id=ed4847ce&"
import script from "./ListCargos.vue?vue&type=script&lang=js&"
export * from "./ListCargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports